//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'BalthazarCT',
  data() {
    return {
      defaultJson:{
        "Pancreas CT grading": "胰腺CT分级 (基于CT平扫)",
        "Pancreatic necrosis area": "胰腺坏死范围（基于增强CT）",
      },
      form:{
        grading:'',
        area:'',
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'A级：胰腺显示正常'},
        {value:"1",name:'B级：胰腺局限或弥漫性肿大'},
        {value:"2",name:'C级：炎症浸润累及胰腺周围脂肪'},
        {value:"3",name:'D级：除胰腺疾病外，胰腺或胰周有单发性积液'},
        {value:"4",name:'E级：胰腺或周有 2 或2 个以上积液积气区'},
      ],
      dataList2:[
        {value:"0",name:'0%'},
        {value:"2",name:' ＜33%'},
        {value:"4",name:'33%~50%'},
        {value:"6",name:'≥50%'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = form.grading + form.area;
        console.log(89, result)
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/BalthazarCT.vue